import { saveAs } from 'file-saver'
/** Module de gestion des documents à ouvrir pour l'utilisateur */

/** Ouvre un fichier dans un nouvel onglet */
export const openFileInNewTab = (file, filename) => {
    const blob = new Blob([file])
    if ("download" in document.createElement("a")) {
        const a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob)
        a.download = filename
        a.click();
    } else {
        workaround(blob, filename)
    }
}

// méthode pour contourner le non fonctionnement sur IE et certains browsers
const workaround = (blob, filename) => {
    if ("msSaveBlob" in window.navigator) {
        window.navigator.msSaveBlob(blob, filename) // IE Solution
    } else {
        saveAs(blob, filename) // Safari Solution
    }
}